// @core/api/endpoints/search/update_search_index.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SearchIndexResponse,
  UpdateSearchIndexRequest,
} from '../../../types/search';

const BASE_PATH = '/search';

/**
 * Update search index
 * Updates a search index configuration including field weights, analyzers, and entity types.
 */
export async function UpdateSearchIndex(
  index_id: string,
  data: UpdateSearchIndexRequest,
  options?: RequestOptions
): Promise<SearchIndexResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/search/indexes/:index_id`;
  requestPath = requestPath.replace(':index_id', encodeURIComponent(index_id));
  const requestOptions = options;
  return client.put<SearchIndexResponse>(requestPath, data, requestOptions);
}
